import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export default function ApprovalTimeline() {
  const [data, setData] = useState(null);

  const fetchTimeline = useCallback(async () => {
    try {
      const res = await api.get("/monitor/timeline", { timeout: 20000 });
      setData(res.data);
    } catch (e) {
      if (e?.response?.status !== 401) console.error("timeline fetch error", e);
    }
  }, []);

  useEffect(() => {
    fetchTimeline();
    const t = setInterval(fetchTimeline, 120000);
    return () => clearInterval(t);
  }, [fetchTimeline]);

  if (!data) {
    return (
      <section className="card timeline-card" data-testid="approval-timeline">
        <div className="card-head"><h2>🛤️ رحلة الموافقة الرسمية</h2></div>
        <div className="monitor-loading"><span className="spinner big" /> جاري التحميل...</div>
      </section>
    );
  }

  const pct = Math.round((data.completed / data.total) * 100);

  return (
    <section className="card timeline-card" data-testid="approval-timeline">
      <div className="card-head">
        <h2>🛤️ رحلة الموافقة الرسمية</h2>
        <span className="timeline-progress-label" data-testid="timeline-progress">
          {data.completed} / {data.total} مراحل مكتملة
        </span>
      </div>
      <div className="timeline-bar">
        <div className="timeline-bar-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="timeline-steps" data-testid="timeline-steps">
        {data.steps.map((s, i) => {
          const state = s.done ? "done" : i === data.current_index ? "current" : "pending";
          return (
            <div key={s.key} className={`timeline-step ${state}`} data-testid={`timeline-step-${s.key}`}>
              <div className="timeline-dot">
                {s.done ? "✓" : i === data.current_index ? "●" : i + 1}
              </div>
              <div className="timeline-info">
                <div className="timeline-label">{s.label}</div>
                <div className="timeline-detail">{s.detail}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
